import { render, staticRenderFns } from "./category_dialog.vue?vue&type=template&id=7f4dbdbc&"
import script from "./category_dialog.vue?vue&type=script&lang=js&"
export * from "./category_dialog.vue?vue&type=script&lang=js&"
import style0 from "./category_dialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports